import React from 'react'
import { globalMenuItemData } from '../../models/axiosModel';
import globalStyles from "../../assets/styles/global.module.scss";
import { MenuItem } from '@mui/material';

interface GlobalMenuGroupProps {
    menuItem: globalMenuItemData,
    index: number,
    handleMenuClose: () => void,
    renderMenuItem: (menuItem: globalMenuItemData, index: number, handleMenuClose: () => void) => React.ReactNode,
} 

const GlobalMenuGroup:React.FC<GlobalMenuGroupProps>  = (props) => {
    
    const {  menuItem, index, handleMenuClose, renderMenuItem } = props;

    const isChildMenuItemsExists = () => {
        return menuItem?.children && menuItem?.children?.length > 0;
    }

    return (
        <>
            <MenuItem
                className={`${globalStyles.menuItemStyle} ${globalStyles.menuItemGroupStyle} ${globalStyles.tertiaryFontSize} ${globalStyles.greyColor} ${globalStyles.primaryFontWeight}`}
                key={index}
                disableRipple
            >
                <span>
                    {menuItem?.label}
                </span>
            </MenuItem>

            {isChildMenuItemsExists() &&
                menuItem?.children?.map((item, index) => {
                    return renderMenuItem(item, index, handleMenuClose);
                })
            }
        </>
    );
}

export default GlobalMenuGroup
